const funcRank = [
  { name: "一键去水印", icon: "ri-drop-line", heat: 98, hot: true, note: "保存无水印原片" },
  { name: "链接解析", icon: "ri-link", heat: 91, hot: false, note: "直出可播地址" },
  { name: "倍速播放", icon: "ri-time-line", heat: 87, hot: false, note: "0.5x–4x 调速" },
  { name: "录屏分段", icon: "ri-record-circle-line", heat: 82, hot: true, note: "直播跟随自动分" },
  { name: "弹幕聚合", icon: "ri-chat-3-line", heat: 76, hot: false, note: "双端同步开聊" },
  { name: "全局聚合", icon: "ri-apps-2-line", heat: 70, hot: false, note: "一站式入口" },
];

const topicRank = [
  { title: "悬疑新剧大结局解析", source: "去水印 + 弹幕聚合", heat: 9960 },
  { title: "顶流演唱会全程录屏", source: "录屏 · 直播跟随", heat: 8430 },
  { title: "热门综艺名场面合集", source: "片段循环 + 倍速", heat: 7120 },
  { title: "二创剪卡点素材库", source: "原画去水印保存", heat: 6680 },
  { title: "跨平台弹幕大乱斗", source: "双端同步对齐", heat: 5230 },
  { title: "晚间连麦整活回顾", source: "录屏 + 解析回放", heat: 4150 },
];

function HeatBar({ value }: { value: number }) {
  return (
    <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
      <div
        className="h-full rounded-full bg-gradient-to-r from-secondary-400 to-accent-500"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}

export default function HotRank() {
  return (
    <section id="rank" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-line" />
              热度榜 · 今日刷新
            </span>
            <h2 className="mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
              今天大家在用哪些吃瓜神器玩法
            </h2>
          </div>
          <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500">
            <i className="ri-arrow-up-line text-accent-600" />
            数据按当日热度实时波动
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {/* 功能热度榜 */}
          <div className="rounded-3xl border border-background-200 bg-background-100 p-4 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-settings-4-line text-accent-600" />
                功能热度榜
              </h3>
              <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800">
                六大玩法
              </span>
            </div>
            <ul className="mt-4 flex flex-col gap-1.5">
              {funcRank.map((it, i) => (
                <li
                  key={it.name}
                  className="flex items-center gap-3 rounded-xl bg-background-50 px-3 py-2.5"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-bold ${
                      i === 0
                        ? "bg-primary-500 text-background-50"
                        : "bg-secondary-100 text-foreground-600"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <i className={`${it.icon} shrink-0 text-lg text-foreground-700`} />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="whitespace-nowrap text-sm font-bold text-foreground-950">
                        {it.name}
                      </span>
                      {it.hot && (
                        <span className="flex items-center gap-0.5 whitespace-nowrap rounded-full bg-accent-100 px-1.5 py-0.5 text-[10px] font-medium text-accent-700">
                          <i className="ri-fire-fill" />
                          热
                        </span>
                      )}
                    </div>
                    <div className="mt-1.5 flex items-center gap-2">
                      <HeatBar value={it.heat} />
                      <span className="w-7 shrink-0 text-right text-xs font-bold text-foreground-600">
                        {it.heat}
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* 内容热度榜 */}
          <div className="rounded-3xl border border-background-200 bg-background-100 p-4 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                <i className="ri-fire-line text-primary-600" />
                内容热点 · 玩法配对
              </h3>
              <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] text-accent-800">
                该配什么玩法
              </span>
            </div>
            <ul className="mt-4 flex flex-col gap-1.5">
              {topicRank.map((it, i) => (
                <li
                  key={it.title}
                  className="flex items-center gap-3 rounded-xl bg-background-50 px-3 py-2.5"
                >
                  <span
                    className={`w-6 shrink-0 text-center font-heading text-lg font-black ${
                      i === 0 ? "animate-heat text-primary-500" : "text-secondary-400"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-foreground-950">
                      {it.title}
                    </p>
                    <p className="mt-0.5 truncate text-xs text-foreground-500">{it.source}</p>
                  </div>
                  <div className="flex shrink-0 flex-col items-end">
                    <span className="flex items-center gap-1 text-xs font-bold text-foreground-700">
                      <i className="ri-fire-fill text-primary-500" />
                      {(it.heat / 1000).toFixed(1)}w
                    </span>
                    <span className="whitespace-nowrap text-[11px] text-foreground-400">
                      {i < 3 ? "持续升温" : "热度稳定"}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}